// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module_container__2Tn6kMJwLGVEu2Pu1C3hor"};